import api from '@/api'
import { login, getPermission } from '@/api/admin'

const state = () => ({
    account: localStorage.account || '',
    token: localStorage.token || '',
    failure_time: localStorage.failure_time || '',
    permissions: []
})

const getters = {
    isLogin: state => {
        let retn = false
        if (state.token) {
            if (new Date().getTime() < state.failure_time * 1000) {
                retn = true
            }
        }
        return retn
    }
}

const actions = {
    login({ commit }, data) {
        return new Promise((resolve, reject) => {
            login({ phone: data.account, password: data.password }).then(res => {
                const { type, access_token } = res.data?.authorize || {}
                commit('setUserData', {
                    account: data.account,
                    token: `${type} ${access_token}`,
                    failure_time: Math.ceil(new Date().getTime() / 1000) + 24 * 60 * 60 * 7 // 7天过期时间
                })
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    logout({ commit }) {
        commit('removeUserData')
        commit('menu/invalidRoutes', null, { root: true })
        commit('menu/removeRoutes', null, { root: true })
    },
    // 获取我的权限
    getPermissions({ commit }) {
        return new Promise(resolve => {
            getPermission({}).then(res => {
                if (Array.isArray(res.permissions)) {
                    const permissions = res.permissions.map(item => {
                        item = item.replace(':', '.')
                        return item
                    })
                    commit('setPermissions', permissions)
                    resolve(permissions)

                }
            }).catch(() => {
                resolve([])

            })
        })
    },
    editPassword({ state }, data) {
        return new Promise(resolve => {
            api.post('member/edit/password', {
                account: state.account,
                password: data.password,
                newpassword: data.newpassword
            }, {
                baseURL: '/mock/'
            }).then(() => {
                resolve()
            })
        })
    }
}

const mutations = {
    setUserData(state, data) {
        localStorage.setItem('account', data.account)
        localStorage.setItem('token', data.token)
        localStorage.setItem('failure_time', data.failure_time)
        state.account = data.account
        state.token = data.token
        state.failure_time = data.failure_time
    },
    removeUserData(state) {
        localStorage.removeItem('account')
        localStorage.removeItem('token')
        localStorage.removeItem('failure_time')
        state.account = ''
        state.token = ''
        state.failure_time = ''
    },
    setPermissions(state, permissions) {
        state.permissions = permissions
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
